<script lang="ts">
    export let color: string = "var(--green)";
    export let gap: string = "1rem";
    export let width: string = "100%";
</script>

<hr style="--color: {color}; --gap:{gap}; --width:{width}" />

<style lang="scss">
    @import "./src/vars";

    hr {
        border: none;
        border-top: 1px solid var(--color);
        margin: var(--gap) 0;
        width: var(--width);
    }
</style>
